document.addEventListener('DOMContentLoaded', () => {
  const productJSONEl = document.querySelector('[id^="ProductJSON-"]');
  if (!productJSONEl) return;
  const productData = JSON.parse(productJSONEl.textContent);

  const getSelectedVariantId = () => {
    const idInput = document.querySelector('[name="id"]');
    return idInput ? Number(idInput.value) : null;
  };

  const filterGalleryByVariant = (variantId) => {
    if (!variantId) return;

    // Main gallery items
    document.querySelectorAll('.product__media-item').forEach(item => {
      const ids = item.dataset.variantIds ? item.dataset.variantIds.split(',').map(Number) : [];
      const shouldShow = ids.length === 0 || ids.includes(variantId);
      item.style.display = shouldShow ? '' : 'none';
    });

    // Thumbnails
    document.querySelectorAll('.thumbnail-list__item').forEach(item => {
      const ids = item.dataset.variantIds ? item.dataset.variantIds.split(',').map(Number) : [];
      const shouldShow = ids.length === 0 || ids.includes(variantId);
      item.style.display = shouldShow ? '' : 'none';
    });

    // Activate first visible main slide (Dawn slider)
    const firstVisible = document.querySelector('.product__media-item:not([style*="display: none"])');
    if (firstVisible) {
      const thumb = document.querySelector(`[data-target="${firstVisible.id}"]`);
      if (thumb) {
        try { thumb.click(); } catch(e){/* ignore */ }
      }
    }
  };

  // Initial run
  filterGalleryByVariant(getSelectedVariantId());

  // ✅ Listen to Shopify variant:change event
  document.addEventListener('variant:change', (event) => {
    const variantId = event.detail.variant.id; // Dawn triggers this with new variant
    alert("hi");
    filterGalleryByVariant(variantId);
  });
});
